import React, { Fragment } from 'react'
import PropTypes from 'prop-types'
import { Tooltip } from '@cgtrader/triangle-ui/dist/src/ssr-index'

import Icon from 'Pods/Shared/Icon/Icon'

import FileRow from 'Pods/Profile/Products/ArchiveSection/FileRow'
import ArchiveFileInfoRow from './ArchiveFileInfoRow'

function FilesListItemArchive({
  file,
  fileTypes,
  fileTypesForSelect,
  removeFile,
  updateFileAttribute,
  addNewFileInfo,
  removeFileInfo,
  onFileNativeTrigger,
  nativeCheckDisabled,
}) {
  const filenameClassName = file.processed === false
    ? 'file-row__filename-text file-row__filename-text--incomplete'
    : 'file-row__filename-text'

  return (
    <Fragment>
      <FileRow id={file.id} key={file.id} archive notSpaced>
        <div className="file-row__col file-row__filename text-semibold">
          <span className={filenameClassName}>{file.name}</span>
          {file.autoGenerated && (
            <Tooltip
              id={`auto-generated-file-${file.id}`}
              content="This version was generated by CGTrader to meet marketplace standards. Your original upload is preserved."
            >
              <Icon className="file-row__filename-tooltip" type={['fas', 'info-circle']} color="green" />
            </Tooltip>
          )}
          {file.processed === false && (
            <Tooltip
              id={`incomplete-file-${file.id}`}
              content={window.I18n.t('profile.model_uploader.file_not_finalized_tooltip')}
            >
              <span className="file-row__status-icon">
                <Icon type={['fas', 'times-circle']} color="red" />
                <span className="sr-only">{window.I18n.t('profile.model_uploader.file_not_finalized_sr')}</span>
              </span>
            </Tooltip>
          )}
        </div>

        <div
          className="file-row__col file-row__col--close"
          onClick={() => removeFile(file.id)}
        >
          <Icon type={['fal', 'times']} notSpaced />
        </div>
      </FileRow>

      {file.itemFileInfos.map((fileInfo) => (
        <ArchiveFileInfoRow
          key={fileInfo.id}
          fileId={file.id}
          fileInfoId={fileInfo.id}
          fileInfo={fileInfo.attributes}
          fileTypes={fileTypes}
          fileTypesForSelect={fileTypesForSelect}
          updateFileAttribute={updateFileAttribute}
          removeFileInfo={removeFileInfo}
          onFileNativeTrigger={onFileNativeTrigger}
          nativeCheckDisabled={nativeCheckDisabled}
        />
      ))}

      <FileRow id={file.id}>
        <div className="file-row__col file-row__col--add-info">
          <div className="text-semibold" onClick={() => addNewFileInfo(file.id)}>+ Add file info</div>
        </div>
      </FileRow>
    </Fragment>
  )
}

FilesListItemArchive.propTypes = {
  file: PropTypes.shape({
    id: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    archive: PropTypes.bool.isRequired,
    processed: PropTypes.bool,
    autoGenerated: PropTypes.bool,
    itemFileInfos: PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.string.isRequired,
        attributes: PropTypes.shape({
          fileTypeId: PropTypes.number,
          fileTypeTitle: PropTypes.string,
          nativeFormat: PropTypes.bool,
          rendererTitle: PropTypes.string,
          rendererId: PropTypes.number,
          rendererVersion: PropTypes.string,
          version: PropTypes.string,
        }).isRequired,
      })
    ).isRequired,
  }).isRequired,
  fileTypes: PropTypes.array.isRequired,
  fileTypesForSelect: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.number.isRequired,
      label: PropTypes.string.isRequired,
    }).isRequired
  ).isRequired,
  removeFile: PropTypes.func.isRequired,
  updateFileAttribute: PropTypes.func.isRequired,
  addNewFileInfo: PropTypes.func.isRequired,
  removeFileInfo: PropTypes.func.isRequired,
  onFileNativeTrigger: PropTypes.func.isRequired,
  nativeCheckDisabled: PropTypes.bool.isRequired,
}

export default FilesListItemArchive
